import { render, staticRenderFns } from "./addStoredValue.vue?vue&type=template&id=6c2ed1e9&scoped=true&"
import script from "./addStoredValue.vue?vue&type=script&lang=js&"
export * from "./addStoredValue.vue?vue&type=script&lang=js&"
import style0 from "./addStoredValue.vue?vue&type=style&index=0&id=6c2ed1e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ed1e9",
  null
  
)

export default component.exports